import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const LANGS = [
  { label: "English", value: "en", icon: "/assets/icons/flags/ic_flag_en.svg" },
  { label: "French", value: "fr", icon: "/assets/icons/flags/ic_flag_fr.svg" },
  { label: "Spanish", value: "es", icon: "/assets/icons/flags/ic_flag_sp.svg" },
  { label: "Portuguese", value: "pt", icon: "/assets/icons/flags/ic_flag_pt.svg" },
  { label: "German", value: "de", icon: "/assets/icons/flags/ic_flag_de.svg" },
  { label: "Japanese", value: "ja", icon: "/assets/icons/flags/ic_flag_jp.svg" },
];

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const [currentLang, setCurrentLang] = useState(() => {
    try {
      const userChoice = localStorage.getItem("user_selected_lang");
      if (userChoice) {
        const code = userChoice.slice(0, 2).toLowerCase();
        const found = LANGS.find((l) => l.value === code);
        if (found) {
          i18n.changeLanguage(code);
          return found;
        }
      }
      if (typeof navigator !== "undefined") {
        const browserLang = (navigator.language || navigator.userLanguage || "").slice(0, 2).toLowerCase();
        const detected = LANGS.find((l) => l.value === browserLang);
        if (detected) {
          i18n.changeLanguage(detected.value);
          return detected;
        }
      }
    } catch (e) {}
    return LANGS[0];
  });

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
    try {
      localStorage.setItem("user_selected_lang", newlang);
      localStorage.setItem("i18nextLng", newlang);
    } catch (e) {}
  };

  useEffect(() => {
    try {
      if (i18n.language) {
        const code = i18n.language.slice(0, 2).toLowerCase();
        localStorage.setItem("i18nextLng", code);
        const selectedLanguage = LANGS.find((l) => l.value === code);
        if (selectedLanguage) setCurrentLang(selectedLanguage);
      }
    } catch (e) {}
  }, [i18n.language]);

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS,
  };
}
